import React from 'react'
import { Dropdown, Row, Button, Divider } from 'antd'

import developerLogin from '../img/developerLogin.png'
import extendLogin from '../img/extendLogin.png'
import sandboxLogin from '../img/sandboxLogin.png'
import arrow from '../img/arrow.png'

export default function LoginStyle(props) {
  const { styles, islogin, history } = props
  const isStg11 = location.href.indexOf('stg11') > -1
  return (
    <div className="fn font16 frn pointer">
      {isStg11 && islogin && (
        <div className="font14" style={{ lineHeight: '20px', marginLeft: '35px'}} onClick={() => history.push('/login')}>登录</div>
      )}
      {!isStg11 && (
        <Dropdown placement="bottomRight" overlay={(
          <div className={styles.dropdownMenu}>
            {islogin && (
              <>
                <Row>
                  <img className={styles.loginIcon} src={developerLogin} />
                  <Button type="text" onClick={() => history.push('/login')}>开发者登录</Button>
                </Row>
                <Divider className={styles.dividerLine} />
              </>
            )
            }
            <Row>
              <img className={styles.loginIcon} src={extendLogin} />
              <Button
                type="text"
                // eslint-disable-next-line max-len
                onClick={() => window.open('https://open-cicd.zhi-niao.com/user-center-web/htm/index.html#/login4?url=aHR0cHM6Ly9vcGVuLWNpY2QuemhpLW5pYW8uY29tL2FsbTIvIy93b3JrYmVuY2g.&n=QUxNMg..&cp=L2FsbTI.&tt=1655284185770')}
              >
                                集成平台登录
              </Button>
            </Row>
            <Divider className={styles.dividerLine} />
            <Row>
              <img className={styles.loginIcon} src={sandboxLogin} />
              <Button type="text" onClick={() => window.open('https://stg11-open.zhi-niao.com/website/index.html#/login')}>沙盒登录</Button>
            </Row>
          </div>
        )}
        >
          <div className={`flex aic ${styles.dropdownTrogger}`}>
            <div className="font14" style={{ lineHeight: '20px', marginLeft: '35px', marginRight: '10px' }}>{islogin ? '登录' : '其他登录'}</div>
            <img src={arrow} className={styles.rowarrow}/>
          </div>
        </Dropdown>
      )}
    </div>
  )
}